import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { useDarkMode } from "../../../contexts/useDarkModeContext";

function ReviewsSection() {
  const { darkMode } = useDarkMode();
  return (
    <Stack
      direction="column"
      sx={{
        bgcolor: darkMode ? "#232323" : "#F5F5F5",
        py: "80px",
        px: "128px",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Avatar
        src="/images/reviewsProfile.png"
        sx={{
          objectFit: "cover",
          width: "212px",
          height: "212px",
          border: "1px solid #4D54F0",
          bgcolor: darkMode ? "#D9D9D9" : "#ffffff",
          p: "14px",
        }}
      ></Avatar>
      <IconButton
        sx={{
          position: "absolute",
          right: 100,
          bgcolor: "#ffffff",
          borderRadius: "6px",
          p: "8px",
          "&:hover": {
            bgcolor: darkMode ? "#D9D9D9" : "",
          },
          "&:active": {
            bgcolor: darkMode ? "#D9D9D9" : "",
          },
        }}
      >
        {" "}
        <Box
          component="img"
          src="/icons/jobBoardRightArrow.svg"
          sx={{
            width: "24px",
            height: "24px",
            borderRadius: "8px",
          }}
        ></Box>
      </IconButton>
      <IconButton
        sx={{
          position: "absolute",
          left: 100,
          bgcolor: "#ffffff", // Default background color
          borderRadius: "6px",
          p: "8px",
          "&:hover": {
            bgcolor: darkMode ? "#D9D9D9" : "",
          },
          "&:active": {
            bgcolor: darkMode ? "#D9D9D9" : "",
          },
        }}
      >
        <Box
          component="img"
          src="/icons/reviewsSectionLeftArrow.svg"
          sx={{
            width: "28px",
            height: "28px",
          }}
        />
      </IconButton>

      <Typography
        variant="body2"
        sx={{
          fontWeight: "400",
          fontSize: "20px",
          lineHeight: "30px",
          fontFamily: "Inter",
          color: darkMode ? "#919191" : "#0E0B33",
          textAlign: "center",
          maxWidth: "1050px",
          py: "20px",
        }}
      >
        "I highly recommend Pitchers to anyone looking for a job. The platform
        is user-friendly and the job listings are always up-to-date. I found my
        dream job thanks to JobLinkup and I couldn't be more happier."
      </Typography>
      <Typography
        variant="body2"
        sx={{
          fontWeight: "700",
          fontSize: "32px",
          lineHeight: "36px",
          fontFamily: "Inter",
          color: darkMode ? "#FFFFFF" : "#0E0B33",
          textAlign: "center",
        }}
      >
        Michael Lawson
      </Typography>
      <Stack
        direction="row"
        sx={{ alignItems: "center", gap: "6px", pt: "10px" }}
      >
        <Box
          component="img"
          src={`/icons/${
            darkMode
              ? "locationIconYellowReviewsSection.svg"
              : "locationIconReviewsSection.svg"
          }`}
          sx={{ width: "22px", height: "22px" }}
        ></Box>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "400",
            fontSize: "16px",
            lineHeight: "26px",
            fontFamily: "Inter",
            color: darkMode ? "#FDDF59" : "#0E0B33",
            textAlign: "center",
          }}
        >
          Seattle, WA
        </Typography>
      </Stack>
    </Stack>
  );
}

export default ReviewsSection;
